import React, { Component } from "react";
import {
    Box,
    Paper,
    Typography,
    Grid,
    TextField,
    FormControlLabel,
    Checkbox,
    Button,
    Divider,
    MenuItem,
    Alert,
    Snackbar,
    InputAdornment,
    Card,
    CardContent,
    Backdrop,
    CircularProgress
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { apiUrl } from "../../../comps/apiUrl";
import withLocation from "../../../comps/withLocation";
import { toast } from "react-toastify";

// Configurações e Tabelas Fiscais para NF-e

const origensMercadoria = [
    { value: "0", label: "0 - Nacional" },
    { value: "1", label: "1 - Estrangeira - Importação direta" },
    { value: "2", label: "2 - Estrangeira - Adquirida no mercado interno" },
    { value: "3", label: "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%" }
];

const unidadesComerciais = [
    { value: "UN", label: "UN - Unidade" },
    { value: "PC", label: "PC - Peça" },
    { value: "KT", label: "KT - Kit" },
    { value: "JG", label: "JG - Jogo" }
];

// Regimes tributários para controle do XML
const regimesTributarios = [
    { value: "1", label: "Simples Nacional" },
    { value: "3", label: "Regime Normal (Lucro Presumido / Real)" }
];

// Situações tributárias corretas para operações de Locação (Isentas / Não Incidentes)
const cstLocacao = [
    { value: "41", label: "41 - Não tributada (Recomendado para Lucro Presumido/Real)" },
    { value: "90", label: "90 - Outras" }
];

const csosnLocacao = [
    { value: "400", label: "400 - Não tributada pelo Simples Nacional (Recomendado)" },
    { value: "900", label: "900 - Outros" }
];

class EditarEquipamento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            items: [],
            toast: {
                open: false,
                message: "",
                severity: "info"
            },
            dados: {
                descricao: "",
                // Campos Fiscais Obrigatórios para emissão de NF-e
                ncm: "",
                gtin: "SEM GTIN",
                uCom: "UN",
                origem: "0",

                // NOVOS CAMPOS FISCAIS ADICIONADOS
                regime_empresa: "1", // Padrão Simples Nacional
                cst_icms: "41",      // Padrão Não Tributada para Regime Normal
                csosn_icms: "400",   // Padrão Não Tributada para Simples Nacional
                aliquota_icms: "0,00", // Locação pura não tem alíquota, mas a tag vai zerada no XML
                cfop_padrao: "5908", // Remessa de bem por conta de contrato de locação

                // Estoques
                stockone: "0",
                stocktwo: "0",
                // Comerciais
                sale: false,
                custo: "",
                custograde: "",
                loca: false,
                day: "",
                week: "",
                biweek: "",
                month: ""
            }
        };
    }

    componentDidMount() {
        console.log(this.props)
        document.title = "Editar Equipamento";
        fetch(`${apiUrl}/maquina/itens/${this.props.params.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {

            response.json().then((data) => {
                var product = data.product
                this.setState({
                    dados: product, loader: false
                });
            });

        })



    }

    handleChange = (e) => {
        const { id, name, value } = e.target;
        const targetId = id || name;
        this.setState((prevState) => ({
            dados: {
                ...prevState.dados,
                [targetId]: value
            }
        }));
    };

    showToast = (message, severity = "info") => {
        this.setState({
            toast: { open: true, message, severity }
        });
    };

    handleCloseToast = () => {
        this.setState((prevState) => ({
            toast: { ...prevState.toast, open: false }
        }));
    };

    formatarMoeda = (valor) => {
        let v = valor.replace(/\D/g, "");
        if (!v) return "";
        v = (v / 100).toFixed(2) + "";
        v = v.replace(".", ",");
        v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        return v;
    };

    handleMoedaChange = (campo, valor) => {
        const valorFormatado = this.formatarMoeda(valor);
        this.setState((prevState) => ({
            dados: {
                ...prevState.dados,
                [campo]: valorFormatado
            }
        }));
    };

    handleSalvar = () => {
        const { dados } = this.state;

        if (!dados.descricao) return this.showToast("O nome do equipamento é obrigatório!", "warning");
        if (!dados.ncm || dados.ncm.length !== 8) return this.showToast("O NCM deve conter exatamente 8 dígitos numéricos!", "warning");
        if (dados.sale && !dados.custograde) return this.showToast("O valor de venda é obrigatório para itens disponíveis para venda!", "warning");

        fetch(`${apiUrl}/atualizar-maquina`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dados)
        })
            .then((res) => {
                if (res.status === 200) {


                    toast.success("Equipamento atualizado com sucesso!")
                    this.props.navigate(-1);



                }
            })

    };

    render() {
        const { dados, toast, loader } = this.state;

        if (loader) {
            //criar um loader material mui
            return (<Box sx={{ p: { xs: 2, md: 4 }, margin: "0 auto" }} maxWidth={1000}>

            </Box>)
        }

        return (
            <Box sx={{ p: { xs: 2, md: 4 }, margin: "0 auto" }} maxWidth={1000}>
                <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, bgcolor: "#fcfcfc" }}>

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h5" component="h1" sx={{ fontWeight: 700, color: "#1a2035" }}>
                            Editar Equipamento
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Insira os dados cadastrais, controle de estoque e as informações tributárias obrigatórias para emissão de NF-e.
                        </Typography>
                    </Box>

                    {/* SEÇÃO 1: Identificação Cadastral */}
                    <Card variant="outlined" sx={{ mb: 4, borderColor: "#e2e8f0", bgcolor: "#f8fafc" }}>
                        <CardContent sx={{ p: 3 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: "#344767" }}>
                                1. Identificação do Produto
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 12 }}>
                                    <TextField
                                        fullWidth
                                        label="Nome/Descrição do Equipamento (Exibe na Nota Fiscal)"
                                        id="descricao"
                                        value={dados.descricao}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    {/* SEÇÃO 2: Atributos Fiscais Atualizada */}
                    <Card variant="outlined" sx={{ mb: 4, borderColor: "#e2e8f0", bgcolor: "#f8fafc" }}>
                        <CardContent sx={{ p: 3 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: "#344767" }}>
                                2. Atributos Fiscais (Obrigatórios para emissão própria de NF-e)
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Código NCM"
                                        id="ncm"
                                        placeholder="8 dígitos"
                                        value={dados.ncm}
                                        onChange={(e) => {
                                            if (/^\d*$/.test(e.target.value) && e.target.value.length <= 8) this.handleChange(e);
                                        }}
                                        helperText="Classificação Fiscal (Ex: 7308.40.00 para Andaimes)"
                                        size="small"
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Código de Barras (GTIN/EAN)"
                                        id="gtin"
                                        value={dados.gtin}
                                        onChange={this.handleChange}
                                        helperText="Use 'SEM GTIN' se não houver código"
                                        size="small"
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        select
                                        label="Unidade Comercial"
                                        name="uCom"
                                        value={dados.uCom}
                                        onChange={this.handleChange}
                                        size="small"
                                    >
                                        {unidadesComerciais.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        select
                                        label="Origem da Mercadoria"
                                        name="origem"
                                        value={dados.origem}
                                        onChange={this.handleChange}
                                        size="small"
                                    >
                                        {origensMercadoria.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>


                            </Grid>
                            <Grid container spacing={2} sx={{ mt: 3 }}>
                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        select
                                        label="Regime Tributário da Empresa"
                                        name="regime_empresa"
                                        value={dados.regime_empresa}
                                        onChange={this.handleChange}
                                        size="small"
                                        helperText="Define se usará CST ou CSOSN na Nota"
                                    >
                                        {regimesTributarios.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                {/* Renderização dinâmica de CST ou CSOSN com base no regime da empresa do cliente */}
                                {dados.regime_empresa === "3" ? (
                                    <Grid item size={{ xs: 12, sm: 3 }}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="CST ICMS (Regime Normal)"
                                            name="cst_icms"
                                            value={dados.cst_icms}
                                            onChange={this.handleChange}
                                            size="small"
                                        >
                                            {cstLocacao.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                ) : (
                                    <Grid item size={{ xs: 12, sm: 3 }}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="CSOSN ICMS (Simples Nacional)"
                                            name="csosn_icms"
                                            value={dados.csosn_icms}
                                            onChange={this.handleChange}
                                            size="small"
                                        >
                                            {csosnLocacao.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                )}

                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="CFOP Padrão de Envio"
                                        id="cfop_padrao"
                                        value={dados.cfop_padrao}
                                        onChange={(e) => {
                                            if (/^\d*$/.test(e.target.value) && e.target.value.length <= 4) this.handleChange(e);
                                        }}
                                        helperText="Ex: 5908 (Estadual)"
                                        size="small"
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, sm: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Alíquota ICMS (%)"
                                        value={dados.aliquota_icms}
                                        onChange={(e) => this.handleMoedaChange("aliquota_icms", e.target.value)}
                                        size="small"
                                        helperText="Mantenha 0,00 para Isento"
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>



                    {/* SEÇÃO 4: Comercialização */}
                    <Card variant="outlined" sx={{ mb: 4, borderColor: "#e2e8f0", bgcolor: "#f8fafc" }}>
                        <CardContent sx={{ p: 3 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: "#344767" }}>
                                3. Regras Comerciais & Valores
                            </Typography>

                            <Box sx={{ mb: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={dados.sale}
                                            onChange={(e) =>
                                                this.setState((prev) => ({ dados: { ...prev.dados, sale: e.target.checked } }))
                                            }
                                            color="primary"
                                        />
                                    }
                                    label="Disponível para Venda Comercial"
                                />
                            </Box>

                            {dados.sale && (
                                <Grid container spacing={2} sx={{ mb: 3, p: 2, bgcolor: "#f1f5f9", borderRadius: 2 }}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Valor de Custo"
                                            value={dados.custo}
                                            onChange={(e) => this.handleMoedaChange("custo", e.target.value)}
                                            InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Valor de Venda"
                                            value={dados.custograde}
                                            onChange={(e) => this.handleMoedaChange("custograde", e.target.value)}
                                            InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                            size="small"
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            <Box sx={{ mb: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={dados.loca}
                                            onChange={(e) =>
                                                this.setState((prev) => ({ dados: { ...prev.dados, loca: e.target.checked } }))
                                            }
                                            color="primary"
                                        />
                                    }
                                    label="Disponível para Locação"
                                />
                            </Box>

                            {dados.loca && (
                                <Grid container spacing={2} sx={{ p: 2, bgcolor: "#f1f5f9", borderRadius: 2 }}>
                                    {[
                                        { key: "day", label: "Diária" },
                                        { key: "week", label: "Semanal" },
                                        { key: "biweek", label: "Quinzenal" },
                                        { key: "month", label: "Mensal" }
                                    ].map((item) => (
                                        <Grid item xs={6} sm={3} key={item.key}>
                                            <TextField
                                                fullWidth
                                                label={item.label}
                                                value={dados[item.key]}
                                                onChange={(e) => this.handleMoedaChange(item.key, e.target.value)}
                                                InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                                size="small"
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                        </CardContent>
                    </Card>

                    <Divider sx={{ my: 4 }} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
                        <Button
                            variant="outlined"
                            color="inherit"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => console.log("Voltar")}
                            sx={{ border: "1px solid #cbd5e1" }}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<SaveIcon />}
                            onClick={this.handleSalvar}
                            sx={{ px: 4, fontWeight: "bold" }}
                        >
                            Atualizar Equipamento
                        </Button>
                    </Box>

                </Paper>

                <Snackbar
                    open={toast.open}
                    autoHideDuration={5000}
                    onClose={this.handleCloseToast}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert severity={toast.severity} variant="filled" sx={{ width: "100%" }}>
                        {toast.message}
                    </Alert>
                </Snackbar>
            </Box>
        );
    }
}

export default withLocation(EditarEquipamento);